import React, {useEffect, useState} from "react";
import ajaxloader from "../../images/ajax-loader.gif";
import Table from "react-bootstrap/Table";
import {useDispatch, useSelector} from "react-redux";
import {filterBMStatus, loadBMStatus, selectBenchmarkState} from "../../reducer/benchmarkSlice";
import THFilter from "../canopia/THFilter";
import THSort from "../canopia/THSort";

export default function Benchmark(props) {

    const dispatch = useDispatch();

    const {tgtDataOrig, tgtData, bmStatusStatus, bmStatusError} = useSelector(selectBenchmarkState);
    const [messages, setMessages] = useState(null);

    const colorClass = 'canopia2';
    const pfBgClass = 'background-light';
    const borderLeftClassName = 'border-top-left';
    const targetSort = "bmStatus";

    useEffect(() => {
        if (bmStatusStatus === "idle") {
            dispatch(loadBMStatus());
        }
    }, [bmStatusStatus, dispatch]);

    if (bmStatusStatus !== 'success') {
        return (
            <div className="main-content">
                <div style={{margin: "1rem auto"}}>
                    <img alt="loading" src={ajaxloader}/>
                </div>
            </div>
        )
    }

    if (!tgtData || tgtData.length === 0) {
        return (
            <div className="main-content">
                <div style={{margin: "1rem auto"}}>
                    <p>No benchmark found</p>
                </div>
            </div>
        )
    }

    let rows = tgtData.map(bmStatus => {

        return <tr key={bmStatus.bmKey}>
            <td>{bmStatus.bmKey}</td>
            <td>{bmStatus.bmName}</td>
            <td className={borderLeftClassName}>{bmStatus.lastBM.lastUpdateFmt}</td>
            <td>{bmStatus.lastBM.dateFmt}</td>
            <td>{bmStatus.status}</td>
            <td>{bmStatus.rePct}</td>
            <td>{bmStatus.lastBM.nbPos}</td>
            <td className={borderLeftClassName}>{bmStatus.prevBM && bmStatus.prevBM.nbPos}</td>
            <td >{bmStatus.min}</td>
            <td>{bmStatus.max}</td>
            <td>{bmStatus.median}</td>
            <td>{bmStatus.histoLength}</td>
        </tr>;
    });

    return (
        <div className="main-content">
            <Table hover className={'portfolio sticky-thc'} style={{marginTop: '20px'}}>
                <thead>
                <tr>
                    <th className={colorClass + " " + pfBgClass} colSpan={2}>
                        Benchmark
                    </th>
                    <th className={colorClass + " " + pfBgClass + " " + borderLeftClassName} colSpan={5}>
                        Last composition
                    </th>
                    <th className={colorClass + " " + pfBgClass + " " + borderLeftClassName} colSpan={5}>
                        History
                    </th>
                </tr>
                <tr>
                    <th className={colorClass + " " + pfBgClass}>
                        <THSort target={targetSort} colName="bmKey" label="Key"/>
                    </th>
                    <th className={colorClass + " " + pfBgClass}>
                        <THSort target={targetSort} colName="bmName" label="Name"/>
                    </th>
                    <th className={colorClass + " " + pfBgClass + " " + borderLeftClassName}>
                        <THSort target={targetSort} colName="lastBM.lastUpdateFmt" label="Last update"/>
                    </th>
                    <th className={colorClass + " " + pfBgClass}>
                        <THFilter targetSort={targetSort} sortCol="lastBM.dateFmt" filterCol="lastBM.dateFmt" label="Latest composition" showLegend={false} selectFunc={selectBenchmarkState}
                                  filterFunc={filterBMStatus} filterValuesSort={"desc"}/>
                    </th>
                    <th className={colorClass + " " + pfBgClass}>
                        <THFilter targetSort={targetSort} sortCol="status" filterCol="status" label="Status" showLegend={false} selectFunc={selectBenchmarkState}
                                  filterFunc={filterBMStatus}/>
                    </th>
                    <th className={colorClass + " " + pfBgClass}>
                        <THSort target={targetSort} colName="re" label="Rel. error"/>
                    </th>
                    <th className={colorClass + " " + pfBgClass}>
                        <THSort target={targetSort} colName="lastBM.nbPos" label="Nb pos"/>
                    </th>
                    <th className={colorClass + " " + pfBgClass + " " + borderLeftClassName}>
                        <THSort target={targetSort} colName="prevBM.nbPos" label="Prev"/>
                    </th>
                    <th className={colorClass + " " + pfBgClass}>
                        <THSort target={targetSort} colName="min" label="Min"/>
                    </th>
                    <th className={colorClass + " " + pfBgClass}>
                        <THSort target={targetSort} colName="max" label="Max"/>
                    </th>
                    <th className={colorClass + " " + pfBgClass}>
                        <THSort target={targetSort} colName="median" label="Median"/>
                    </th>
                    <th className={colorClass + " " + pfBgClass}>
                        <THSort target={targetSort} colName="histoLength" label="Length"/>
                    </th>
                </tr>
                </thead>
                <tbody>
                {rows}
                </tbody>
            </Table>
        </div>
    );
}
